<template>
  <ion-page>
    <master-layout pageTitle="مشاهده مأموریت">
      <Loading v-if="!pageLoaded"></Loading>
      <div v-if="pageLoaded">
        <IonCardContent v-if="mission">
          <DataTable :card="true" :datas="datas" :headers="headers"></DataTable>
        </IonCardContent>
        <div v-if="error"></div>
      </div>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "../../components/DataTable";

import {
 IonPage,IonCardContent
} from "@ionic/vue";
import {mapActions} from "vuex";
import Loading from "../../components/Loading";

export default {
  name : 'mDetail',
  data()
  {
    return {
      datas : [],
      pageLoaded : false,
      mission : null,
      headers: [
        'نوع',
        'شماره',
        'مشتری',
        'وضعیت',
        'امکانات',
      ],
    };
  },
  mounted()
  {
    this.init();
  },
  methods:{
    ...mapActions('mission',{
      getPaymentMissionFullInfo : 'getPaymentMissionFullInfo'
    }),
    async init()
    {
      const id = this.$route.params.id;
      this.pageLoaded = false;
      const result = await this.getPaymentMissionFullInfo(id);
      if (result)
      {
        if (result.ok)
        {
          this.mission = result.mission;
          const items = result.items;
         const datas = [];
          for (let i = 0; i < items.length; i++)
          {
            const d = items[i];
            let type = d.entity_type;
            if (type === 'customer')
              type = 'مشتری';
            else if (type === 'order')
              type = 'سفارش';
            else if (type === 'contract')
              type = 'آیتم قراردادی';
            let is_visit = '<span class="text-danger">ویزیت نشده</span>';
            if (d.is_visit)
              is_visit = '<span class="text-success">ویزیت شده</span>';
            let option = '<router-link to="/paymentMission/ItemView/'+d._id+'" class="btn btn-info"><i class="far fa-edit"></i></router-link>&nbsp;';
            if (d.location)
                option +='<a href="geo:'+d.location[1]+','+d.location[0]+'" class="btn btn-warning"><i class="far fa-directions"></i></a>';
            datas.push([type,d.number,d.fullname,is_visit,option]);
          }
          this.datas = datas;
          this.pageLoaded = true;
        }
        else
        {
          this.pageLoaded = true;
          this.error = result.error;
        }
      }
      else
      {
        this.pageLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور.';
      }
    }
  },
  components: {
    Loading,
     IonPage,IonCardContent,DataTable
  },
  watch : {
    "$route.path": {
      handler(newUrl,oldUrl)
      {
        if (newUrl.toLowerCase().indexOf('paymentmission/view/') >= 0 && oldUrl.toLowerCase().indexOf('paymentmission/view/') < 0)
        {
          this.init()
        }
      },
      deep:true
    },
  }

};
</script>

<style scoped>

</style>